import axios, { AxiosRequestConfig } from 'axios';
// config
import { ASSETS_API } from 'src/config-global';

// ----------------------------------------------------------------------

const axiosInstance = axios.create({ baseURL: ASSETS_API });

axiosInstance.interceptors.response.use(
  (res) => res,
  (error) => Promise.reject((error.response && error.response.data) || 'Something went wrong')
);

export default axiosInstance;

// ----------------------------------------------------------------------

export const fetcher = async (args: string | [string, AxiosRequestConfig]) => {
  const [url, config] = Array.isArray(args) ? args : [args];

  const res = await axiosInstance.get(url, { ...config });

  return res.data;
};

// ----------------------------------------------------------------------

export const endpoints = {
  uploadChannelAvatar: 'upload/channel/avatar',
  uploadCategoryAvatar: 'upload/category/avatar',
  uploadUserAvatar: 'upload/user/avatar',
  uploadBadgeAvatar: 'upload/badge/avatar',
  uploadBunnyFile: 'bunny-upload',
};
